export const useHandleArrowScroll = (ref: React.RefObject<HTMLDivElement>) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const container = ref.current
        if (!container) return
        const scrollAmount = 0
        switch (event.key) {
            case 'ArrowDown':
                container.scrollBy({ top: scrollAmount, behavior: 'smooth' })
                event.preventDefault()
                break
            case 'ArrowUp':
                container.scrollBy({ top: -scrollAmount, behavior: 'smooth' })
                event.preventDefault()
                break
            case 'PageDown':
                container.scrollBy({ top: container.clientHeight, behavior: 'smooth' })
                event.preventDefault()
                break
            case 'PageUp':
                container.scrollBy({ top: -container.clientHeight, behavior: 'smooth' })
                event.preventDefault()
                break
        }
    }

    return { handleKeyDown }
}
